import type { RescueModule } from './rescue-types.js';
import { patternPulse } from './modules/pattern-pulse/pattern-pulse.js';
import { breathingOrb } from './modules/breathing-orb/breathing-orb.js';
import { blackjack } from './modules/blackjack/blackjack.js';
import { airHockey } from './modules/air-hockey/air-hockey.js';
import { infinityBreaker } from './modules/infinity-breaker/infinity-breaker.js';
import { ghostImages } from './modules/ghost-images/ghost-images.js';

export const RESCUE_MODULES: RescueModule[] = [
  infinityBreaker,
  airHockey,
  blackjack,
  patternPulse,
  ghostImages,
  breathingOrb,
];

export function getModule(id: string): RescueModule | undefined {
  return RESCUE_MODULES.find((m) => m.id === id);
}
